module.exports = __webpack_public_path__ + "static/img/pic14.b15eb6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic14.png
// module id = hQlY
// module chunks = 0